module.exports = __webpack_public_path__ + "img/Loose Stone.1270cae2.png";